import React, { useMemo } from 'react';
import { TextOverflowTooltip } from 'src/common';

interface GTFrameworkCellProps {
  controls: { controlFramework?: { shortname?: string | null } | null; control_identifier?: string | null }[];
}

export const GTFrameworkCell: React.FC<GTFrameworkCellProps> = ({ controls }) => {
  const items = useMemo(() => {
    return controls.map((el) => `${el.controlFramework?.shortname} (${el.control_identifier})`);
  }, [controls]);
  return (
    <TextOverflowTooltip tooltipText={items.join('<br/>')} place="right">
      <>{items.join(', ')}</>
    </TextOverflowTooltip>
  );
};
